import React from 'react'
import IsSuggestPlanAvailable from './isSuggestPlan'

const SuggestedPlanFn = ({ showOtherPlan, onRadioChange }) => {
  return (
    <div>
      <IsSuggestPlanAvailable
        showOtherPlan={showOtherPlan}
        onRadioChange={onRadioChange}
      />
    </div>
  )
}

export default SuggestedPlanFn